var map = {
	"app/delivery/delivery.module": [
		"../../../../../src/app/delivery/delivery.module.ts",
		"delivery.module"
	],
	"app/demo/demo.module": [
		"../../../../../src/app/demo/demo.module.ts",
		"common",
		"demo.module"
	],
	"app/kpi/kpi.module": [
		"../../../../../src/app/kpi/kpi.module.ts",
		"common",
		"kpi.module"
	],
	"app/manage/manage.module": [
		"../../../../../src/app/manage/manage.module.ts",
		"manage.module"
	],
	"app/order/order.module": [
		"../../../../../src/app/order/order.module.ts",
		"common",
		"order.module"
	],
	"app/price/price.module": [
		"../../../../../src/app/price/price.module.ts",
		"price.module"
	],
	"app/sale-return/sale-return.module": [
		"../../../../../src/app/sale-return/sale-return.module.ts",
		"common",
		"sale-return.module"
	],
	"app/statement/statement.module": [
		"../../../../../src/app/statement/statement.module.ts",
		"statement.module"
	],
	"app/vmi/vmi.module": [
		"../../../../../src/app/vmi/vmi.module.ts",
		"vmi.module"
	],
	"app/wechat-check/wechat-check.module": [
		"../../../../../src/app/wechat-check/wechat-check.module.ts",
		"wechat-check.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main